<template>
    <div>
        <!--add new category-->

        <template>
            <v-row justify="center">
                <v-dialog v-model="showInfo" max-width="900" hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>اطلاعات بیشتر</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon dark @click="showInfo = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>

                        <div>
                            <more-information v-if="showInfo" :bought="hasBought"
                                              :information="moreInfo"></more-information>
                        </div>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <!--add new category-->

        <!--                filtering-->

        <div class="row mx-auto">
            <div class="col-md-6">
                <v-btn
                        color="orange"
                        fab
                        small
                        rounded
                        class="my-19"
                        @click="sheet=!sheet"
                >
                    <span class="fa fa-filter"></span>
                </v-btn>
                <v-chip
                        close
                        @click="destroyFilter"
                        close-icon="mdi-delete"
                        color="red"
                        class="my-19 mx-4"
                        outlined
                >حذف فیلترها
                </v-chip>
                <!--                <v-chip-->
                <!--                        close-->
                <!--                        @click="destroyFilter"-->
                <!--                        close-icon="mdi-delete"-->
                <!--                        color="red"-->
                <!--                        class="my-19"-->
                <!--                        outlined-->
                <!--                >پرفروش ترین-->
                <!--                </v-chip>-->
                <!--                <v-chip-->
                <!--                        close-->
                <!--                        @click="destroyFilter"-->
                <!--                        close-icon="mdi-delete"-->
                <!--                        color="red"-->
                <!--                        class="my-19"-->
                <!--                        outlined-->
                <!--                >دارای تخفیف-->
                <!--                </v-chip>-->
                <!--                <v-chip-->
                <!--                        close-->
                <!--                        @click="destroyFilter"-->
                <!--                        close-icon="mdi-delete"-->
                <!--                        color="red"-->
                <!--                        class="my-19"-->
                <!--                        outlined-->
                <!--                >ارزانترین-->
                <!--                </v-chip>-->
                <!--                <v-chip-->
                <!--                        close-->
                <!--                        @click="destroyFilter"-->
                <!--                        close-icon="mdi-delete"-->
                <!--                        color="red"-->
                <!--                        class="my-19"-->
                <!--                        outlined-->
                <!--                >گرانترین-->
                <!--                </v-chip>-->

            </div>
            <div class="col-md-4 mr-auto mt-15">
                <v-text-field
                        v-model="search.search"
                        label="جستجوی عنوان"
                        required
                        clearable
                        :loading="loading"
                        clear-icon="mdi-close-circle-outline"
                        dense
                        prepend-inner-icon="fa fa-search"
                        class="mt-1 float-left"
                ></v-text-field>
            </div>
        </div>
        <v-bottom-sheet
                v-model="sheet"
                inset
                class="pt-15"
        >
            <v-sheet
                    class="text-center"
                    height="450px"
            >
                <v-toolbar dark color="primary">


                    <v-toolbar-title>فیلتر بانک موردنظر</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                        <v-btn icon dark @click="sheet = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>

                </v-toolbar>
                <v-progress-linear
                        color="primary"
                        indeterminate
                        v-if="loading"
                        reverse
                ></v-progress-linear>
                <!--        filtering-->
                <div class="col-md-12">
                    <div class="row mx-4 pt-10">
                        <div class="col-md-4">
                            <admin-category ref="category" parent-name="جستجو براساس دسته بندی"></admin-category>
                        </div>
                        <div v-if="!search.country" class="col-md-4">
                            <province-selector ref="province"></province-selector>
                        </div>
                        <div v-if="!search.country" class="col-md-4">
                            <city-selector ref="city"></city-selector>
                        </div>
                        <div class="col-md-4">
                            <v-switch
                                    v-model="search.country"
                                    inset
                                    label="کشوری"
                            ></v-switch>
                        </div>
                    </div>
                    <div class="d-flex mx-4">

                    </div>
                    <v-range-slider
                            v-if="sheet"
                            v-model="range"
                            :max="max"
                            :min="min"
                            hide-details
                            class="align-center"
                    >
                        <template v-slot:prepend>
                            <v-text-field
                                    :value="range[0]"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 100px"
                                    @change="$set(range, 0, $event)"
                            ></v-text-field>
                        </template>
                        <template v-slot:append>
                            <v-text-field
                                    :value="range[1]"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 100px"
                                    @change="$set(range, 1, $event)"
                            ></v-text-field>
                        </template>
                    </v-range-slider>

                </div>
                <!--cards list-->
            </v-sheet>
        </v-bottom-sheet>

        <div v-if="archives.length > 0" class="row" dir="rtl">
            <div v-for="item in archives" class="col-md-4 offset-m2 offset-l4" :key="item.id">
                <div class="product-card">
                    <div class="card z-depth-4 pt-0 mt-0">
                        <div @click="sendInfo(item.id,item.bought)" class="card-image pt-0 mt-0">
                            <a v-if="item.discount" href="#"
                               class="btn-floating btn-large price waves-effect waves-light red darken-3">
                                {{ item.discount }}٪ تخفیف
                            </a>
                            <img :src="item.image" alt="product-img">
                        </div>
                        <ul class="card-action-buttons">
                            <li @click="likeProduct(item.id)"><a v-b-tooltip.hover="'افزودن به لیست علاقه مندی ها'"
                                                                 :class="item.liked ? 'btn-floating waves-effect waves-light white accent-2' : 'btn-floating waves-effect waves-light white' ">
                                <i class="material-icons like" :style="!item.liked ?{color:'black'} :{color:'red'} "
                                   :id="item.id">{{ item.liked ? 'favorite' : 'favorite_border' }}</i>

                            </a>

                            </li>
                            <li v-if="item.bought" @click=" downloader(item.id)">
                                <a v-b-tooltip.hover="'دانلود بانک اطلاعاتی'"
                                   class="btn-floating waves-effect waves-light purple">
                                    <i class="material-icons">file_download</i>
                                </a>
                            </li>

                            <li @click=" sendInfo(item.id,item.bought)">
                                <a v-b-tooltip.hover="'مشاهده اطلاعات بیشتر'"
                                   class="btn-floating waves-effect waves-light "
                                   style="background-color: darkblue!important;">
                                    <i class="material-icons">help_outline</i>
                                </a>
                            </li>
                        </ul>
                        <div class="card-content">
                            <div class="row">
                                <div class="col s12 mt-5">
                                    <p class="pb-1">
                                        <strong class="text-dark font-weight-bold"
                                                style="color: darkblue!important;">{{ item.title }}</strong> <br/>
                                    </p>
                                    <p> {{ item.description }}</p>
                                    <div class="row px-0 mb-0 mx-auto">
                                        <div class="col-md-3">
                                            <v-btn v-if="!item.bought" @click="buyProduct(item.id)" rounded outlined
                                                   class="mt-4 btn-buy">
                                                <span class="fa fa-shopping-cart mr-2"></span>
                                                خرید
                                            </v-btn>
                                            <v-btn v-else @click="downloader(item.id)" rounded outlined
                                                   class="mt-4  btn-download">
                                                <span class="material-icons">file_download</span>
                                                دانلود فایل
                                            </v-btn>
                                        </div>
                                        <div class="text-left mr-auto col-md" style="min-height: 4rem">
                                            <p class="mt-4 text-info mt-4 font-size-h6">{{ item.final_price |currency }}
                                                ﷼ </p>
                                            <p v-show="item.discount" class="text-muted mr-auto"
                                               style="text-decoration: #1c0152 line-through">{{ item.amount |currency }}
                                                ﷼ </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row my-0 py-0 mr-1">
                                <div class="mt-0 pt-0" style="width: 95%;">
                                    <div v-if="item.province != null" class="chip mt-0 pt-0">#{{ item.province }}</div>
                                    <div v-else-if="item.city != null" class="chip mt-0 pt-0">#{{ item.city }}</div>
                                    <div v-else class="chip mt-0 pt-0">#کشوری</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="text-center mx-auto" v-if="failed && archives.length === 0">
            <img class="mx-auto img-fluid" :src="require('/public/media/img/no-result.svg')" alt="" width="675" height="450">
            <p>متاسفانه نتیجه ای یافت نشد! اطلاعات درخواستی خود را دوباره چک کنید.</p>
        </div>
        <atom-spinner
                v-if="loading"
                :animation-duration="1500"
                :size="100"
                class="mx-auto"
                color="indigo"
        />
        <!--cards list-->
        <a :href="downloadUrl" id="dl" ref="dl" :download="name"></a>
    </div>
</template>

<script>

import {Axios2, Bus} from "../../../main";
import TitleRibbon from "../uiBeautifier/titleRibbon";
import MoreInformation from "./moreInformation";
import CitySelector from "../mainComponents/citySelector";
import ProvinceSelector from "../mainComponents/provinceSelector";
import AdminCategory from "../mainComponents/adminCategory";
import {AtomSpinner, HalfCircleSpinner, HollowDotsSpinner} from 'epic-spinners'

export default {
    name: "BankCards",
    components: {
        MoreInformation, TitleRibbon, CitySelector,
        ProvinceSelector, AdminCategory, HollowDotsSpinner, HalfCircleSpinner, AtomSpinner
    },
    props: {
        url: {
            default: "user/archives"
        },
        phone: {
            default: false
        },

    },
    data() {
        return {
            archives: [],
            min: 0,
            max: 100000000,
            range: [0, 100000000],
            downloadUrl: '',
            name: 'بانک',
            moreInfo: '',
            showInfo: false,
            failed: false,
            sheet: false,
            loading: false,
            observer: null,
            next_page: null,
            categoryModel: '',
            hasBought: false,
            timer: null,
            search: {
                search: undefined,
                category: undefined,
                province: undefined,
                city: undefined,
                country: false,
                price: []
            },
        }
    },
    methods: {
        getArchives(url = this.url) {
            this.loading = true;
            Axios2.get(url, {
                params: Object.assign({
                    dir: "desc",
                    length: 9,
                    type: this.phone ? "phone" : "data"
                }, this.search)
            }).then((response) => {
                this.archives = this.archives.concat(response.data.data.data);
                // this.next_page = response.data.data.next_page_url.replace('http://', 'https://');
                this.next_page = response.data.data.next_page_url;
                this.observer.observe(this.$refs.dl);
                this.loading = false;
                this.failed = response.data.data.data.length == 0;
            })
        },
        likeProduct(id) {
            Axios2.put(`user/like/${id}`).then((res) => {
                this.archives.find((x) => x.id === id).liked = res.data.data;

            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            });
        },
        buyProduct(id) {
            this.$modal.yesNo('تایید خرید!', 'آیا از خرید این بانک اطلاعاتی اطمینان دارید؟ پس از خرید، عودت مبلغ تحت هیچ شرایطی امکان پذیر نمی باشد.', 'neg').then((x) => {
                if (x === true) {
                    Axios2.put(`user/shop/${id}`).then((res) => {
                        this.$nextTick(() => {
                            this.$modal.success('موفق!', res.data.message);
                            this.archives.find((x) => x.id === id).bought = true;
                        })

                    }).catch((error) => {
                        this.$nextTick(() => {
                            this.$modal.error('خطا!', '', error.response.data.message);
                        })
                    });
                }
            })
        },
        downloader(id) {
            this.$modal.showLoading();
            Axios2.post(`/user/download/${id}`, [], {
                responseType: "arraybuffer",
                timeout: -1
            }).then((x) => {
                const domString = new TextDecoder('UTF-8').decode(x.data);

                this.name = decodeURI(x.headers["name"]);

                this.downloadUrl = window.URL.createObjectURL(new Blob(['\ufeff' + domString], {
                    type: 'text/plain;charset=utf-8',
                    encoding: 'UTF-8'
                }));

                this.$nextTick(() => {
                    this.$refs.dl.click();
                });
            }).finally(() => {
                this.$modal.hideLoading();
            })
        },
        sendInfo(id, buy) {
            this.showInfo = true;
            this.hasBought = buy
            this.moreInfo = id
        },
        destroyFilter() {
            if (!this.search.country) {
                this.$refs.province.province_id = undefined;
                this.$refs.city.city_id = undefined;
                this.$refs.category.parent_id = null;
                this.$refs.category.category = ''
            } else {
                this.$refs.category.parent_id = null;
                this.$refs.category.category = ''
            }
            this.search = {
                search: undefined,
                category: undefined,
                province: undefined,
                city: undefined,
                country: false,
                price: []
            },
                this.archives = [];
            this.getArchives();
        }
    },
    watch: {
        search: {
            deep: true,
            handler() {
                clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.archives = [];
                    this.getArchives();
                }, 700)
            }
        },
        range(value) {
            this.search.price = value
        },
        categoryModel(value) {
            if (value === null || value === '' || value === undefined)
                this.search.category = undefined;
        }
    },
    created() {
        this.getArchives();
    },
    mounted() {
        this.observer = new IntersectionObserver((entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && this.next_page !== null) {
                    this.observer.unobserve(this.$refs.dl);
                    this.getArchives(this.next_page);
                }
            });
        }));

        Bus.$on('getProvince', (value) => {
            this.search.province = value;
        });

        Bus.$on('getCity', (value) => {
            this.search.city = value;
        });

        Bus.$on('categoryName', (value) => {
            this.categoryModel = value
        });

        Bus.$on('getCategoryId', (value) => {
            this.search.category = value;
        });

    }
}
</script>

<style scoped src="@/assets/css/bankCard.css">
</style>